module.exports = __webpack_public_path__ + "media/images/area/feature/hokkaido/related/th_5-5772b5f4650a4fe2aa38331e7ce24c4f.jpg";